<ds-comcol-page-header
  [attr.lang]="metadataValue.language"
  [name]="metadataValue.value">
</ds-comcol-page-header>
